import { openDrpRequest } from '@/utils/request'
import { ResMarketListItem } from '../supplier/market'

// 根据市场域名查询配置
interface loadMarketByDomainParamsType {
    marketDomain: string
}

export function loadMarketByDomain(params: loadMarketByDomainParamsType): Promise<API.RootObject<ResMarketListItem>> {
    return openDrpRequest.get('/open/marketInfo/loadMarketByDomain', {
        params,
    })
}
